module.exports = __webpack_public_path__ + "static/media/Star_Vector_Color-01.7566fca8.svg";